@if (initialized) {
  <div>
    @if (!summaries.length) {
      <div class="mat-body-strong">No status</div>
    }
    <div class="status-container">
      @for (summary of summaries; track summary) {
        <div class="status-card link" [class.active]="summary.completed"
          [routerLink]="[project.id, 'report', summary.date | date: 'yyyy-MM-dd']">
          <div class="mat-subtitle-1">
            <a class="no-style link" [routerLink]="[project.id, 'report', summary.date | date: 'yyyy-MM-dd']">
              {{summary.date | dateFormat: 'long'}}
            </a>
          </div>
          @if (summary.todo) {
            <div class="mat-caption" i18n>
        Awaiting creation ({summary.todo, plural, =1 {1 report} other {{{summary.todo}} reports}})
      </div>
          }
          @if (summary.draft) {
            <div class="mat-caption" i18n>
        Awaiting submissions ({summary.draft, plural, =1 {1 report} other {{{summary.draft}} reports}})
      </div>
          }
          @if (summary.submitted) {
            <div class="mat-caption" i18n>
        Awaiting approvals ({summary.submitted, plural, =1 {1 report} other {{{summary.submitted}} reports}})
      </div>
          }
          @if (summary.rejected) {
            <div class="mat-caption" i18n>
        Rejected ({summary.rejected, plural, =1 {1 report} other {{{summary.rejected}} reports}})
      </div>
          }
          @if (summary.approved) {
            <div class="mat-caption" i18n>
        Approved ({summary.approved, plural, =1 {1 report} other {{{summary.approved}} reports}})
      </div>
          }
        </div>
      }
    </div>
  </div>
}
